import { combineReducers } from "redux";
import { handleAction } from "redux-actions";
import { route } from "actions/navigation";

export default combineReducers({
  currentRoute: handleAction(route, (state, { payload }) => payload, null),
});
